var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workpostscanproduct",attrs:{"id":"workpostscanproduct"}},[(_vm.workpost)?_c('workstation-scan-products',{ref:"scanner",attrs:{"workstation":_vm.workpost,"action-buttons":_vm.actionButtons}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }